import { RoundResult } from 'game-logic';
import { GameServices } from '../../services/game-services';
import { assertNever } from 'src/games/common/helper';
import { BlackjackStylesType, BlackjackTranslationsType } from '../../model/blackjack-types';

export class ResultsViewModel {
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get backgroundColor() {
    return this.gameServices.gameThemeService.getNumericalRGB(
      BlackjackStylesType.BackgroundPrimary,
    );
  }

  constructor(private gameServices: GameServices) {}

  public resultLabel(result: RoundResult): string {
    const translationService = this.gameServices.gameTranslationService;

    switch (result) {
      case RoundResult.Push:
        return translationService.getTranslation(BlackjackTranslationsType.Push);
      case RoundResult.CroupierWin:
        return translationService.getTranslation(BlackjackTranslationsType.DealerWins);
      case RoundResult.PlayerWin:
        return translationService.getTranslation(BlackjackTranslationsType.Won);
      case RoundResult.PlayerBust:
        return translationService.getTranslation(BlackjackTranslationsType.Bust);
      case RoundResult.PlayerBlackjack:
        return translationService.getTranslation(BlackjackTranslationsType.Blackjack);
      default:
        assertNever(result, 'Invalid result state');
    }
  }
}
